import React, { useEffect, useState } from "react";
import Header from "../layouts/Header";
import Banner from "../components/service/Banner";
import Footer from "../layouts/Footer";
import JoinOurTeam from "../components/Home/JoinOurTeam";
import CommonDesign from "../components/service/commonDesign";
import { Col, Container, Row } from "react-bootstrap";
import ListCard from "../components/ListCard";
import { motion } from "motion/react";
import { Helmet } from "react-helmet";

const TalentEnable = () => {
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: "smooth",
    });
    const timer = setTimeout(() => setHasLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const titleData = {
    service_name: "OUR TALENT ENABLEENT SERVICES",
    title: "Flexible Workforce Solutions, Tailored to Your Needs",
    content:
      "Flexible, on-demand talent solutions to meet your hiring needs with speed and precision.",
  };

  const ListCardArray = [
    {
      icon: "/images/flexible.svg",
      title: "Contingent Workforce Solutions",
      header: "Flexible talent, delivered when you need it most.",
      descrption:
        "Leverage a flexible, on-demand workforce to meet project-based or temporary staffing needs.",
      list: {
        item1:
          "Access to highly skilled professionals for short-term assignments.",
        item2: "Quick turnaround to help meet business demands with agility.",
        item3: "Flexible contracts with scalable staffing options.",
      },
    },
  ];

  const ListCardArrayTwo = [
    {
      icon: "/images/employee.svg",
      title: "Full-Time Employee (FTE) Talent Search",
      header: "Connecting you with the perfect long-term fit.",
      descrption:
        "Find the ideal talent for your permanent workforce with our expert hiring solutions. Why choose us?",
      list: {
        item1: "Industry-specific recruitment expertise.",
        item2:
          "Robust screening and interview processes to identify top talent.",
        item3: "Support for onboarding to ensure seamless integration.",
      },
    },
  ];
  const ListCardArrayThree = [
    {
      icon: "/images/recuritment.svg",
      title: "Recruitment Process Outsourcing",
      header: "Effortless hiring, expertly managed.",
      descrption:
        "Streamline your hiring processes and focus on your core business while we manage your recruitment lifecycle.",
      list: {
        item1: "End-to-end management of recruitment, from sourcing to hiring.",
        item2: "Advanced analytics to improve hiring quality and reduce costs.",
        item3: "Scalable solutions designed to grow with your business.",
      },
    },
  ];
  const ListCardArrayFour = [
    {
      icon: "/images/human-resources.svg",
      title: "Bulk Talent Search & Support",
      header: "Scaling your workforce with speed & precision.",
      descrption:
        "Handle high-volume hiring needs efficiently with our specialized bulk talent services. What You Get:",
      list: {
        item1: "Large-scale recruitment drives for project ramp-ups.",
        item2: "Dedicated support teams to ensure a smooth process.",
        item3: "Quick turnaround times without compromising quality.",
      },
    },
  ];
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: hasLoaded ? 1 : 0 }}
      transition={{ duration: 0.7 }}
    >
      <Helmet>
        <title>Volto Consulting | Business &amp; Technology Solutions</title>
        <meta
          name="description"
          content="Volto Consulting provides innovative business and technology solutions to drive success in a digital world."
        />
        <meta
          name="keywords"
          content="Volto Consulting, business consulting, IT solutions, technology strategy, digital transformation"
        />
        <meta name="author" content="Volto Consulting" />
        <meta
          property="og:title"
          content="Volto Consulting | Business &amp; Technology Solutions"
        />
        <meta
          property="og:description"
          content="Volto Consulting offers expert business and IT consulting services to enhance your digital transformation journey."
        />
      </Helmet>
      <div className="volto-homepage service light-theme">
        <Header  />
        <Banner 
    mode="dark"
    bannerImg="/images/talent-banner.webp"
    title="Talent Enablement"
    main_content="At Volto Consulting, we specialize in connecting businesses with the right talent, enabling organizations to achieve their goals with a workforce that’s skilled, dynamic, and ready to excel."
    />
      <section className="list-card-container">
          <CommonDesign data={titleData} />
          <Container>
            <Row>
              <Col lg={6}>
                <div className="ListCard">
                  <ListCard array={ListCardArray} />
                </div>
              </Col>
              <Col lg={6}>
                <div className="ListCard">
                  <ListCard array={ListCardArrayTwo} />
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="talent-process volto-section pb-80">
          <Container>
            <Row>
              <Col lg={4}>
                <div className="process ListCard">
                  <ListCard array={ListCardArrayThree} />
                </div>
              </Col>
              <Col lg={4}>
                <img
                  className="img-fluid talent-vector"
                  src="/images/talent-vector.svg"
                  alt="talent-vector"
                />
              </Col>
              <Col lg={4}>
                <div className="process ListCard">
                  <ListCard array={ListCardArrayFour} />
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <JoinOurTeam image={"/images/join-our-team.webp"} />
        <Footer />
      </div>
    </motion.div>
  );
};

export default TalentEnable;
